function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M624.705,200.001l0.685,-0.001l1.313,0.002c55.614,0.153 113.297,9.998 113.297,9.998l0,126l-64.562,0c-63.603,0 -83.438,39.467 -83.438,79.957l0,96.043l142,0l-22.7,148l-119.3,0l0,357.78c244.769,-38.41 432,-250.226 432,-505.78c0,-282.77 -229.23,-512 -512,-512c-282.77,0 -512,229.23 -512,512c0,255.554 187.231,467.37 432,505.78l0,-357.78l-130,0l0,-148l130,0l0,-112.8c0,-128.063 76.133,-198.916 192.705,-199.199Z",
    style: {
      fill: "#1877f2",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo2);
export default __webpack_public_path__ + "static/media/facebookLogo2.5d2dfd592869658531d970a52d8632c2.svg";
export { ForwardRef as ReactComponent };